<template>
  <v-tooltip right>
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        data-testid="createButton-button-create"
        fab
        class="create-button"
        x-small
        elevation="0"
        :class="{ small: small, gradient: gradient }"
        :data-tourid="tourId"
        :disabled="disabled"
        :to="to"
        @mouseleave="$emit('mouseleave', $event)"
        @mouseenter="$emit('mouseenter', $event)"
        @click="$emit('click', $event)"
      >
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>
    </template>
    {{ tooltip }}
  </v-tooltip>
</template>

<script>
export default {
  name: 'CreateButton',
  props: {
    to: { required: false },
    gradient: Boolean,
    disabled: Boolean,
    small: Boolean,
    tooltipText: {
      type: String,
      required: false,
    },
    tourId: {
      type: String,
      required: false,
    },
  },

  computed: {
    tooltip() {
      return this.tooltipText ?? this.$t('common.button.create')
    },
  },
}
</script>

<style lang="scss" scoped>
.create-button {
  background-color: $color-blue !important;

  &.gradient {
    background-image: linear-gradient(
      180deg,
      #74aef0 0%,
      #4f75e9 100%
    ); // Not the same as $color-gradient-blue
  }

  &.small {
    width: 24px !important;
    height: 24px !important;
  }

  &.small i {
    width: 20px !important;
    height: 20px !important;
    font-size: 20px !important;
  }

  &.v-btn--disabled.v-btn--has-bg {
    background: $color-blue-grey !important;
    opacity: 0.4;

    i {
      color: $color-white !important;
    }
  }

  i {
    width: 24px !important;
    height: 24px !important;
    font-size: 24px !important;
  }
}
</style>
